<template>
  <form>
    <!-- 推薦 -->
    <div>
      <div class="form-title-container">
        <p>推薦</p>
      </div>
      <button
        v-for="(recommendOption, index) in recommendOptions"
        :key="index"
        @click="handleClickRecommend(recommendOption)"
        type="button"
      >
        {{ recommendOption.label }}
      </button>
    </div>
    <!-- 祝賀詞與名稱 -->
    <div>
      <div class="form-title-container">
        <p>祝賀詞與名稱</p>
        <div
          class="templeNameLimit"
          :class="{ 'is-over': isGreetingsAndNameOver }"
        >
          <span>{{ greetingsAndNameLength }}</span>
          <span>/</span>
          <span>{{ greetingsAndNameLimit }}</span>
        </div>
      </div>
      <input
        type="text"
        placeholder="例：恭祝王小明誕聖"
        v-model="engraving_content.content.commemorativeMedalGreetingsAndName"
      />
    </div>
    <!-- 祝賀詞 -->
    <div>
      <div class="form-title-container">
        <p>祝賀詞</p>
        <div
          class="templeNameLimit"
          :class="{ 'is-over': isGreetingMessageOver }"
        >
          <span>{{ greetingMessageLength }}</span>
          <span>/</span>
          <span>{{ greetingMessageLimit }}</span>
        </div>
      </div>
      <input
        type="text"
        placeholder="祝賀詞"
        v-model="engraving_content.content.commemorativeMedalGreetingMessage"
      />
    </div>
    <!-- 祝賀圖片 -->
    <div class="dropdown_title">
      <p class="title">祝賀圖片</p>
      <a href="#" v-on:click.prevent="showDropDown = !showDropDown">
        <div class="title">{{ getImageOptionLabel }}</div>
        <i
          :class="{
            'fa-caret-up': showDropDown,
            'fa-caret-down': !showDropDown,
          }"
          class="fa"
          aria-hidden="true"
        ></i>
      </a>
      <transition name="slide-fade">
        <div class="choice" v-if="showDropDown">
          <ul>
            <li v-for="(option, index) in imageOptions" :key="index">
              <span v-on:click="updateImageOption(option.value)">{{
                option.label
              }}</span>
            </li>
          </ul>
        </div>
      </transition>
    </div>
    <!-- 圖片敘述 -->
    <template
      v-if="
        engraving_content.content.commemorativeMedalGreetingImageOption ===
        'custom'
      "
    >
      <div>
        <div class="form-title-container">
          <p>圖片敘述</p>
          <div
            class="templeNameLimit"
            :class="{ 'is-over': isImageCustomOver }"
          >
            <span>{{ imageCustomLength }}</span>
            <span>/</span>
            <span>{{ imageCustomLimit }}</span>
          </div>
        </div>
        <input
          type="text"
          placeholder="例：汽車"
          v-model="
            engraving_content.content.commemorativeMedalGreetingImageCustom
          "
        />
      </div>
      <p>製圖人員會依照您提供的圖片敘述作為後續與你討論完稿的依據。</p>
    </template>
    <!-- 贈送人姓名-->
    <div>
      <div class="form-title-container">
        <p>贈送人姓名（也可加上甲子年號、日期）</p>
        <div class="templeNameLimit" :class="{ 'is-over': isSenderNameOver }">
          <span>{{ senderNameLength }}</span>
          <span>/</span>
          <span>{{ senderNameLimit }}</span>
        </div>
      </div>
      <input
        type="text"
        placeholder="例：王大明 2025.09.09"
        v-model="engraving_content.content.commemorativeMedalSenderName"
      />
    </div>
    <p class="note">畫面呈現為示意圖，正式製作稿件將由專業人員編排製版完成。</p>
  </form>
</template>
<script>
import {
  engravingDefaultContent,
  commemorativeMedalGreetingImageOptions,
} from "@/constData/engravingData";
import { recommendOptions } from "./constData.js";

export default {
  name: "MetalTextCommemorativeMedal",
  data() {
    return {
      showDropDown: false,
      recommendOptions: recommendOptions,
      imageOptions: commemorativeMedalGreetingImageOptions,
      engraving_content: {
        type: "commemorative_medal",
        content: {
          commemorativeMedalGreetingsAndName: "",
          commemorativeMedalGreetingMessage: "",
          commemorativeMedalGreetingImageOption: "nothing",
          commemorativeMedalGreetingImageCustom: "",
          commemorativeMedalSenderName: "",
        },
      },
      // 字數限制（從 store 讀取）
      greetingsAndNameLimit: 0,
      greetingMessageLimit: 0,
      imageCustomLimit: 0,
      senderNameLimit: 0,
    };
  },
  created() {
    // 從 store 讀取現有資料或使用預設值
    const storeContent = this.$store.getters.currentCustom.engraving_content;

    if (storeContent.type === "commemorative_medal") {
      this.engraving_content = storeContent;
    } else {
      this.engraving_content.content = {
        ...engravingDefaultContent.commemorative_medal,
      };
    }

    // 獲取字數限制配置
    let componentCode = this.$store.getters.getComponentCode;
    let textLimit =
      this.$store.getters.textSettingByComponentCode(componentCode);

    // 計算總字數限制
    this.greetingsAndNameLimit =
      textLimit.commemorativeMedalGreetingsAndName.lineLimit *
      textLimit.commemorativeMedalGreetingsAndName.textLimit;
    this.greetingMessageLimit =
      textLimit.commemorativeMedalGreetingMessage.lineLimit *
      textLimit.commemorativeMedalGreetingMessage.textLimit;
    this.imageCustomLimit =
      textLimit.commemorativeMedalGreetingImageCustom.textLimit;
    this.senderNameLimit =
      textLimit.commemorativeMedalSenderName.lineLimit *
      textLimit.commemorativeMedalSenderName.textLimit;
  },
  computed: {
    // 取得當前選項的 label 文字
    getImageOptionLabel() {
      const option = this.imageOptions.find(
        (opt) =>
          opt.value ===
          this.engraving_content.content.commemorativeMedalGreetingImageOption
      );
      return option ? option.label : "";
    },
    // 字數計數
    greetingsAndNameLength() {
      return this.engraving_content.content.commemorativeMedalGreetingsAndName
        .length;
    },
    greetingMessageLength() {
      return this.engraving_content.content.commemorativeMedalGreetingMessage
        .length;
    },
    imageCustomLength() {
      return this.engraving_content.content
        .commemorativeMedalGreetingImageCustom.length;
    },
    senderNameLength() {
      return this.engraving_content.content.commemorativeMedalSenderName.length;
    },
    // 是否超過限制
    isGreetingsAndNameOver() {
      return this.greetingsAndNameLength > this.greetingsAndNameLimit;
    },
    isGreetingMessageOver() {
      return this.greetingMessageLength > this.greetingMessageLimit;
    },
    isImageCustomOver() {
      return this.imageCustomLength > this.imageCustomLimit;
    },
    isSenderNameOver() {
      return this.senderNameLength > this.senderNameLimit;
    },
    // 是否有任何欄位超過限制
    isAnyFieldOver() {
      // 檢查祝賀詞與名稱
      if (this.isGreetingsAndNameOver) return true;

      // 檢查祝賀詞
      if (this.isGreetingMessageOver) return true;

      // 檢查贈送人姓名
      if (this.isSenderNameOver) return true;

      // 只在選擇「自訂」時檢查圖片敘述
      if (
        this.engraving_content.content.commemorativeMedalGreetingImageOption ===
          "custom" &&
        this.isImageCustomOver
      ) {
        return true;
      }

      return false;
    },
  },
  watch: {
    "engraving_content.content": {
      handler() {
        this.updateCostom();
      },
      deep: true,
    },
  },
  methods: {
    updateCostom() {
      let payload = {
        key: "engraving_content",
        content: this.engraving_content,
      };
      this.$store.dispatch("updateCostom", payload);
    },
    updateImageOption(value) {
      this.engraving_content.content.commemorativeMedalGreetingImageOption =
        value;

      // 切換選項時清空自訂欄位
      if (value !== "custom") {
        this.engraving_content.content.commemorativeMedalGreetingImageCustom =
          "";
      }

      this.updateCostom();
      this.showDropDown = false;
    },
    checkoutTextLimit() {
      return this.isAnyFieldOver ? "over" : "ok";
    },
    handleClickRecommend(recommendOption) {
      this.engraving_content.content = {
        ...recommendOption.defaultEngravingContent,
      };
    },
  },
};
</script>
<style scoped lang="scss">
button {
  border: 1px solid $primaryDeepColor;
  background-color: transparent;
  color: $primaryDeepColor;
  font-size: 17px;
  padding: 8px 13px;
  margin-right: 10px;
}

.templeNameLimit {
  color: #4a4a4a;
  transition: color 0.2s ease;

  &.is-over {
    color: red;
  }
}
</style>
